import { PayloadAction, Selector, createSlice } from "@reduxjs/toolkit";
import { PropertyPath, get, set } from "lodash";

import { RootState } from "../store";
import { formUpdater } from "../types/form";
import { OnboardingState } from "../types/onboarding";

const initialState: OnboardingState = {
  root_namespace_name: "",
  organization_name: "",
};

const slice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setOnboardingProperty(
      state: OnboardingState,
      action: PayloadAction<formUpdater>,
    ): void {
      set(state || {}, action.payload.path, action.payload.value);
    },
  },
});

export const { reducer, actions } = slice;
export const { setOnboardingProperty } = actions;

export const getOnboardingProperty =
  (path: PropertyPath): Selector =>
  (store: RootState) => {
    return get(store.onboarding, path, "") as string;
  };
